import React from "react";
import Logo from "../../assets/images/LEFTKOAST-LOGO.png";
import { Link } from "react-router-dom";
import {
  House,
  Compass,
  Notebook,
  Bookmark,
  Cookie,
  HeartHandshake,
  UserCircle,
} from "lucide-react";
import { setGenre, setGenreID } from "../../redux/slices/genre";
import { useDispatch, useSelector } from "react-redux";
import "./Sidenav.css";

function Sidenav({ openSidenav, setOpenSidenav }) {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);

  const handleMenuClick = (link) => {
    setOpenSidenav(false);
    if (link === "/discover") {
      dispatch(setGenre(""));
      dispatch(setGenreID(""));
    }
  };

  const middleItems = [
    {
      icon: <House size={25} />,
      link: "/",
    },
    {
      icon: <Compass size={25} />,
      link: "/discover",
    },
    {
      icon: <Notebook size={25} />,
      link: "/library",
    },
    {
      icon: <Bookmark size={25} />,
      link: "/favorites",
    },
  ];

  const bottomItems = [
    {
      icon: <Cookie size={25} />,
      link: "/privacy",
      className: "",
    },
    {
      icon: <HeartHandshake size={25} />,
      link: "/terms-of-service",
      className: "",
    },
    {
      icon: <UserCircle size={25} />,
      link: user ? "/profile" : "/login",
      className: "user-icon",
    },
  ];

  return (
    <nav className={`Sidenav ${openSidenav ? "open" : ""}`}>
      <img src={Logo} alt="logo" width={40} />
      <ul>
        {middleItems.map((item, index) => (
          <li key={index}>
            <Link to={item.link} onClick={() => handleMenuClick(item.link)}>
              {item.icon}
            </Link>
          </li>
        ))}
      </ul>
      <ul>
        {bottomItems.map((item, index) => (
          <li key={index} className={item.className}>
            <Link to={item.link} onClick={() => handleMenuClick(item.link)}>
              {item.icon}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Sidenav;
